module.exports = __webpack_public_path__ + "img/2f_r_tonya.42b2f424.jpg";